import React from 'react';
import classNames from 'classnames';

import Card from '@components/libraryV2/Card';
import Link from '@components/libraryV2/Link';
import ProductSvg from '@components/libraryV2/ProductSvg';
import { slugToCamelCase } from '@lib/helpers';

import * as styles from './styles.module.scss';

const ProductInfo = ({ name, product, productStyle }) => {
  return (
    <div className={styles.product}>
      <ProductSvg className={styles.svg} product={product} />{' '}
      <span className={classNames(styles.name, styles[productStyle])}>{name}</span>
    </div>
  );
};

const ExamLink = (props) => {
  const { children, className, name, product, withCard } = props;
  const productStyle = slugToCamelCase(product);
  const to = `/exams/${product}/overview/`;

  if (withCard) {
    return (
      <Link className={className} to={to}>
        <Card className={classNames(styles.card, styles[productStyle])}>
          <ProductInfo name={name} product={product} productStyle={productStyle} />
          {children ? <div className={styles.children}>{children}</div> : null}
        </Card>
      </Link>
    );
  }

  return (
    <Link className={classNames(styles.layout, styles.plain, className)} to={to}>
      <ProductInfo name={name} product={product} productStyle={productStyle} />
    </Link>
  );
};

export default ExamLink;
